import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { ButtonFactory } from '../../factories/ButtonFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Button extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new ButtonFactory
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes', 'containerClasses']
  }

  elementContents() {
    return ['text', 'link', 'event', 'eventData']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'Button',
      icon: 'fa-hand-pointer',
      variations: this.variationsInfo()
    }
  }
}